module.exports = __webpack_public_path__ + "static/img/bg_about_b.c4eef12c.png";